import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import {
	StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

export const messageStepGraph: Beacon<StepMap> = {
	[steps.Message]: [steps.ContactInfo],
};

export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	// What ever logic is needed to determine the next step
	return steps.ContactInfo as StepMap;
};
